import { api } from './client'

export interface LoginRequest {
    username: string
    password: string
}

export interface LoginResponse {
    user: {
        id: string
        username: string
        full_name: string
        is_active: boolean
    }
    expires_at: string
    // Chỉ có mặt khi tài khoản bật OTP: mật khẩu đúng nhưng chưa được cấp phiên,
    // `user` khi đó không có mặt.
    otp_required?: boolean
    challenge_token?: string
    email_masked?: string
    resend_after_seconds?: number
}

export interface ResendOtpResponse {
    email_masked: string
    expires_at: string
    resend_after_seconds: number
}

export interface ImpersonationIdentity {
    id: string
    username: string
}

export interface MeResponse {
    user_id: string
    username: string
    full_name?: string
    permissions?: string[]
    // Mã vai trò đang bật của người dùng hiệu lực. Màn quản trị phân quyền gác
    // theo vai trò `admin`, không theo permission.
    roles?: string[]
    // SHOP_ENABLED của bản deploy: bật / tắt cả giao diện bán lẻ (server:shop).
    shop_enabled?: boolean
    // ZALO_OA_ENABLED của bản deploy: bật / tắt Quản trị → Zalo ZBS (server:zalo-oa).
    zalo_oa_enabled?: boolean
    // Present only while an admin is viewing as another user. The user_id /
    // username / permissions above are the EFFECTIVE (target) user; this block
    // exposes both identities.
    impersonating?: {
        actor: ImpersonationIdentity
        target: ImpersonationIdentity
    } | null
}

export const authApi = {
    login: (data: LoginRequest) => api.post<LoginResponse>('/auth/login', data),

    verifyOtp: (data: { challenge_token: string; code: string }) =>
        api.post<LoginResponse>('/auth/login/otp/verify', data),

    resendOtp: (data: { challenge_token: string }) =>
        api.post<ResendOtpResponse>('/auth/login/otp/resend', data),

    logout: () => api.post<{ message: string }>('/auth/logout'),

    refresh: () => api.post<LoginResponse>('/auth/refresh'),

    me: () => api.get<MeResponse>('/auth/me'),

    // changePassword: backend route not implemented yet
    // changePassword: (data: { current_password: string; new_password: string }) =>
    //     api.put<{ message: string }>('/auth/change-password', data),
}
